<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{configuration.title}}</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    @if (renameModal.infoDescription) {
      <p class="common-modal__content-header-info">{{renameModal.infoDescription}}</p>
    }
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-text-simple
        [field]="renameModal.nameInfo"
        [preSelectItem]="renameModal.name"
        (itemSelected)="itemSelected($event, 'name')">
      </field-type-text-simple>
      @if (renameModal.suffix) {
        <field-type-text-simple
          [field]="renameModal.suffixInfo"
          [preSelectItem]="renameModal.suffix"
          (itemSelected)="itemSelected($event, 'suffix')">
        </field-type-text-simple>
      }
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="validateFields()">
      <span class="common-button__text-title">{{renameModal.acceptButton}}</span>
    </button>
  </div>
</div>
